export default __webpack_public_path__ + "68a812558fc0627b77f5dbcb119bdd86.gif";